import React from 'react';
import { styled } from '@mui/material';
import Check from '@mui/icons-material/Check';

function StepIcon({ active, completed, className }) {
  return (
    <StepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className='StepIcon-completedIcon' /> : <div className='StepIcon-circle' />}
    </StepIconRoot>
  );
}

export default StepIcon;

const StepIconRoot = styled('div')(() => ({
  color: 'var(--text-default)',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .StepIcon-completedIcon': {
    color: 'var(--color-primary)',
    zIndex: 1,
    fontSize: 18,
  },
  '& .StepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: 'var(--color-primary)',
      },
    },
  ],
}));
